// The ContentIQ project stage chip — the at-a-glance 7-step ladder (design
// settled 2026-10-08): Setting up → Copy in progress → Pages in build →
// Package complete → Client review → Ready to launch → Launched. The stage is
// COMPUTED server-side (services/lifecycle.py) and rides every project
// payload as {key, label, number, of}; this renders it the same everywhere
// a project is listed (Home resume lane, the all-projects list, the
// Deployment panel header), so the ladder can't drift between surfaces.
//
// Purely presentational; colors come from wizardTheme families per stage.
import React from 'react';
import { HUES, INK, NEUTRAL, STATE, RADII } from '../utils/wizardTheme';

const STAGE_LOOK = {
  setting_up: { fg: INK.secondary, bg: NEUTRAL.chipBg },
  copy_in_progress: { fg: HUES.lp.text, bg: HUES.lp.tint },
  pages_in_build: { fg: HUES.strategy.text, bg: HUES.strategy.tint },
  pages_accepted: { fg: STATE.done.text, bg: STATE.done.tint },
  client_review: { fg: HUES.scripts.text, bg: HUES.scripts.tint },
  ready_to_launch: { fg: STATE.gate.text, bg: STATE.gate.tint },   // your move: request launch
  launched: { fg: STATE.done.deep, bg: STATE.done.tint },
};

export default function CiqStageChip({ stage, showNumber = true }) {
  if (!stage || !stage.key) return null;
  const look = STAGE_LOOK[stage.key] || STAGE_LOOK.setting_up;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '6px',
      background: look.bg, color: look.fg, borderRadius: RADII.pill,
      padding: '3px 12px', fontSize: '11px', fontWeight: 600, whiteSpace: 'nowrap',
    }}>
      {/* "stage 4/7", never a bare "4/7" — next to a label like "Package
          complete" a bare fraction reads as a page count (Edward, 2026-10-09,
          on a 1-page project whose chip said "4/7 Pages accepted"). */}
      {showNumber && (
        <span style={{ opacity: 0.75, fontVariantNumeric: 'tabular-nums', fontWeight: 500 }}>
          stage {stage.number}/{stage.of}
        </span>
      )}
      {stage.key === 'launched' ? '🚀 ' : ''}{stage.label}
    </span>
  );
}
